// redux/slices/subscriptionSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ApiClient from 'src/config/ApiClient';
import { normalizeSubscriptions } from 'src/pages/Subscription/subscriptionUtils';

// const API_URL = "https://www.bbgrestaurant.com/bbgapi";

// Thunk to fetch subscriptions
export const fetchSubscriptions = createAsyncThunk(
  "subscription/fetchSubscriptions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(`/subscription`);
      return normalizeSubscriptions(response.data?.data);
    } catch (error) {
      if (error.response?.status === 404 && error.response.data?.msg === "No subscriptions found") return [];
      console.error("Error fetching subscriptions:", error);
      return rejectWithValue(
        "Subscription plans are temporarily unavailable. Please try again."
      );
    }
  }
);


// Redux Slice
const subscriptionSlice = createSlice({
  name: "subscription",
  initialState: {
    subscriptions: [], // Will store normalized subscriptions
    loading: false,
    error: null,
    status: "idle",
  },
  reducers: {
    clearSubscriptionStatus(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Subscriptions
      .addCase(fetchSubscriptions.pending, (state) => {
        state.loading = true;
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        state.status = "success";
        // Flatten the data structure if there are nested arrays
        state.subscriptions = action.payload.flat();
      })
      .addCase(fetchSubscriptions.rejected, (state, action) => {
        state.loading = false;
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { clearSubscriptionStatus } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
